module.exports = __webpack_public_path__ + "img/account-root.6237acc8.svg";